import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import React, { useState } from 'react';

const HearingListFilters = ({ handleSort, formatMessage }) => {
  const [sortChangeStatusMessages, setSortChangeStatusMessages] = useState([]);

  const sortList = (event) => {
    handleSort(event.target.value);

    const newMessage = {
      id: Math.random(),
    };
    setSortChangeStatusMessages([newMessage]);

    // Clear the message after 5 seconds
    setTimeout(() => {
      setSortChangeStatusMessages([]);
    }, 5000);
  };

  return (
    <div className="hearing-list__filter-bar clearfix">
      <div className="sr-only">
        {sortChangeStatusMessages && sortChangeStatusMessages.map(alert => (
          <div key={alert.id} aria-live="assertive" role="status">
            <FormattedMessage id="orderHasBeenChanged" />
          </div>
        ))}
      </div>
      <FormGroup controlId="formControlsSelect" className="hearing-list__filter-bar-filter">
        <ControlLabel className="hearing-list__filter-bar-label">
          <FormattedMessage id="sort" />
        </ControlLabel>
        <FormControl
          className="digi-select"
          componentClass="select"
          placeholder="select"
          onChange={event => sortList(event)}
        >
          <option value="-created_at">{formatMessage({ id: 'newestFirst' })}</option>
          <option value="created_at">{formatMessage({ id: 'oldestFirst' })}</option>
          <option value="-close_at">{formatMessage({ id: 'lastClosing' })}</option>
          <option value="close_at">{formatMessage({ id: 'firstClosing' })}</option>
          <option value="-open_at">{formatMessage({ id: 'lastOpen' })}</option>
          <option value="open_at">{formatMessage({ id: 'firstOpen' })}</option>
          <option value="-n_comments">{formatMessage({ id: 'mostCommented' })}</option>
          <option value="n_comments">{formatMessage({ id: 'leastCommented' })}</option>
        </FormControl>
      </FormGroup>
    </div>
  );
};

HearingListFilters.propTypes = {
  handleSort: PropTypes.func,
  formatMessage: PropTypes.func,
};

export default HearingListFilters;